<h3 fxLayout="row" fxLayoutAlign="space-between center" mat-dialog-title>
    <div fxLayout="row" fxLayoutAlign="start center">
        <command *ngIf="!showBidQuotes" [command]="backCommand" attr.aria-label="Command-Back-{{Title}}-Purchasing"></command>
        

        <div class="forge-typography--heading4">{{Title}}</div>
    </div>

    <forge-icon-button *ngIf="canEdit" (click)="addAction()">
        <forge-tooltip placement="bottom">{{PanelName}}</forge-tooltip>
    <forge-icon name="add"></forge-icon>
        </forge-icon-button>
</h3>

<mat-dialog-content>
    <busy-indicator *ngIf="!isLoaded" [big]="true"></busy-indicator>

    <ng-container *ngIf="isLoaded">
        <bid-quotes *ngIf="showBidQuotes" [model]="bidQuotes" [canEdit]="canEdit" (delete)="deleteBidQuote($event)" (viewAttachments)="switchToAttachments($event)" (viewNotes)="switchToNotes($event)">
        </bid-quotes>

        <attachments-container *ngIf="showAttachments" [canAdd]="canEdit" [canEdit]="canEdit" [model]="currentAttachments" (add)="appendAttachments($event)" (delete)="removeAttachment($event)">
        </attachments-container>

        <notes *ngIf="showNotes" [model]="currentNotes" (delete)="deleteNote($event)" [viewOnly]="!canEdit">
        </notes>

        <div class="error forge-typography--label1">
            <span *ngIf="hasInvalidBidQuoteError">One or more bid/quotes are invalid.</span>
            <span *ngIf="hasInvalidNoteError">One or more notes are invalid.</span>
            <span *ngIf="hasInvalidAttachmentError">One or more attachments are invalid.</span>
            <span *ngIf="hasMultipleAwardedError">Only one bid/quote can be awarded.</span>
        </div>
    </ng-container>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
    <command-bar [commands]="dialogCommands" telemetry="CmdBar-CommandKey-{{Title}}-Purchasing">
    </command-bar>
</mat-dialog-actions>